
<ng-template [ngIf]="config?.headingType === 1">
  <h1 [ngClass]="'config.class' ? config.class : ''" [innerHTML]=" config?.text | multiLang | code2txt : legend | safe: 'html' "></h1>
</ng-template>
<ng-template [ngIf]="config?.headingType === 2">
  <h2 [ngClass]="'config.class' ? config.class : ''" [innerHTML]=" config?.text | multiLang | code2txt : legend | safe: 'html' "></h2>
</ng-template>
<ng-template [ngIf]="config?.headingType === 3">
  <h3 [ngClass]="'config.class' ? config.class : ''" [innerHTML]=" config?.text | multiLang | code2txt : legend | safe: 'html' "></h3>
</ng-template>
<ng-template [ngIf]="config?.headingType === 4">
  <h4 [ngClass]="'config.class' ? config.class : ''" [innerHTML]=" config?.text | multiLang | code2txt : legend | safe: 'html' "></h4>
</ng-template>
<ng-template [ngIf]="config?.headingType === 5">
  <h5 [ngClass]="'config.class' ? config.class : ''" [innerHTML]=" config?.text | multiLang | code2txt : legend | safe: 'html' "></h5>
</ng-template>
<ng-template [ngIf]="config?.headingType === 6">
  <h6 [ngClass]="'config.class' ? config.class : ''" [innerHTML]=" config?.text | multiLang | code2txt : legend | safe: 'html' "></h6>
</ng-template>
